:host {
  --uui-panel-title-font-weight: var(--uui-font-weight-bold);
  --uui-panel-title-font-size: 1.5rem;
  --uui-panel-title-line-height: var(--uui-large-line-height);

  /* title */
  --uui-panel-title-color: var(--uui-theme-core-500);
  --uui-panel-title-hover-color: var(--uui-theme-core-400);
  --uui-panel-title-active-color: var(--uui-theme-core-600);
  --uui-panel-title-direction: column;
  --uui-panel-title-align-items: flex-start;

  --uui-panel-header-button-pointer-events: auto;
  --uui-panel-header-button-icon-display: block;
  --uui-panel-header-vertical-alignment: center;

  /* description */
  --uui-panel-description-font-weight: var(--uui-font-weight-normal);
  --uui-panel-description-font-size: var(--uui-default-font-size);
  --uui-panel-description-line-height: var(--uui-default-line-height);
  --uui-panel-description-color: var(--uui-theme-secondary-400);
}

:host {
  font-family: var(--uui-primary-font-family);
  width: 100%;
}

:host([direction="row"]) {
  --uui-panel-title-direction: row;
  --uui-panel-title-align-items: flex-end;
}

button {
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  width: 100%;
  outline: inherit;
  pointer-events: var(--uui-panel-header-button-pointer-events);
  display: flex;
  align-items: var(--uui-panel-header-vertical-alignment);
}

.uui-expansion-title-container {
  display: flex;
  flex-direction: var(--uui-panel-title-direction);
  align-items: var(--uui-panel-title-align-items);
  width: 100%;
  box-sizing: border-box;
  margin-right: 1.25rem;
}

button:hover {
  --uui-panel-title-color: var(--uui-panel-title-hover-color);
  cursor: pointer;
}

button:active, button:focus-visible {
  --uui-panel-title-color: var(--uui-panel-title-active-color);
}

.uui-expansion-title {
  color: var(--uui-panel-title-color);
  margin-right: 0.625rem;
  font-size: var(--uui-panel-title-font-size);
  line-height: var(--uui-panel-title-line-height);
  text-align: left;
  font-weight: var(--uui-panel-title-font-weight);
}

.uui-expansion-description {
  margin-top: 0;
  font-weight: var(--uui-panel-description-font-weight);
  font-size: var(--uui-panel-description-font-size);
  line-height: var(--uui-panel-description-line-height);
  color: var(--uui-panel-description-color);
  text-align: left;
  max-width: 560px;
}

.uui-expansion-icon::after {
  display: var(--uui-panel-header-button-icon-display);
  content: var(--uui-panel-title-icon);
  width: 1.25rem;
  height: 1.25rem;
}
